import * as React from 'react';
export const useLatestRef = (value) => {
  let valueRef = React.useRef(value);
  React.useEffect(() => {
    valueRef.current = value;
  }, [value]);
  return valueRef;
};
